import './App.css';
import React from 'react';
//import TodoApp from './todo/TodoApp';
import LoginPage from './canine-u/comp/LoginPage';

function App() {
  return (
    <>
      <LoginPage></LoginPage>
    </>
  )
}

export default App;